import { ReactElement } from 'react'
import {
  InfoListWrapper,
  InfoWrapper,
  NotesWrapper,
  Notes
} from './subcomponents'
import { H1, H3, Large, Body } from '../../../typography'
import { useHistory } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import { Header, Container } from '../subcomponents'
import ROUTES from '../../../const/routes'
import strings from '../../../locale/en'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../redux/store'
import { Loader, TostMessage } from '../../../components'

const TestInstructions = (): ReactElement => {
  const { testPaperDetails, isLoading, error } = useSelector(
    (state: RootState) => ({
      testPaperDetails: state.test?.testPaperDetails,
      isLoading: state.test?.isLoading,
      error: state.test?.error
    }),
    shallowEqual
  )
  const history = useHistory()
  const {
    test: { duration, notes, takeTest, questions, attempt }
  } = strings

  if (isLoading) return <Loader />

  return (
    <Container id="container">
      <TostMessage show={!!error} message={error}></TostMessage>
      <Header isStacked>
        <H1>{testPaperDetails?.testPaper?.name}</H1>
        <H3>{strings?.test?.instructions}</H3>
      </Header>
      <InfoListWrapper>
        <InfoWrapper
          icon={['far', 'clock']}
          info={duration}
          suffix={`${testPaperDetails?.testPaper?.duration} mins`}
        />
        <InfoWrapper
          icon={['far', 'question-circle']}
          info={questions}
          suffix={`${testPaperDetails?.testPaper?.questionCount}`}
        />
        <InfoWrapper
          icon={['fas', 'sync']}
          info={attempt}
          suffix={`${testPaperDetails?.attemptedCount} of ${testPaperDetails?.testPaper?.attempts}`}
        />
      </InfoListWrapper>
      <NotesWrapper>
        <Large> {notes} </Large>
        <Notes>
          <Body>
            {`1. The Market scheme is displayed on top, for each question`}
          </Body>
          <Body>{`2. To select an answer, click on the option.`}</Body>
          <Body>{`3. To diselect an answer, click on the option again.`}</Body>
          <Body>
            {`4. You can change your answer by clicking on some other option.`}
          </Body>
          <Body>
            {`5. You can Mark a question for review if you want to revisit the
            question during the exam.`}
          </Body>
          <Body>
            {`6. You can click on 'Next' or 'previous' to go through the question
            sequentially.`}
          </Body>
          <Body>
            {`7. A Number list of all questions appears at the bottom of your
            screen, Under 'jump to Question'. You can the questions in any order
            within a section or any sections by clicking on question number
            given on the list.`}
          </Body>
          <Body>
            {`8. 'Attempted' questions will be marked blue, 'Marked for Review'
            questions will be marked Yellow.`}
          </Body>
          <Body>
            {`9. You can use rough sheet while taking the test. Do not use
            calculators, log tables, dictionaries or any other printed/ online
            reference material during the test.`}
          </Body>
          <Body>
            {`10. Click on 'Submit Test' ONLY after the completing exam. An exam once submitted cannot be resumed.`}
          </Body>
          <Body>
            {`11. By Clicking on 'Start Exam' you agree that you have read all the instructions and you abide by them.`}
          </Body>
        </Notes>
        <Button
          variant="success"
          size="lg"
          onClick={() => history.push(ROUTES.TEST)}
          disabled={!!error}
        >
          {takeTest}
        </Button>
      </NotesWrapper>
    </Container>
  )
}

export default TestInstructions
